<template>
  <div class="container">
    <NavigationBar/>
    <div class="title">Request account deleting</div>
    <div class=" d-flex justify-content-center">
      <div class="wrapper">
        <div v-if="sent" class="text-success p-2 w-100 text-center">
          <div class="mb-4">
            Thank you! We will get in touch with you. You can always contact us on contact@momfident.io
          </div>
        </div>
        <div v-if="err" class="text-danger p-2 w-100 text-center">Error! Please try again later.</div>
        <div v-else-if="!sent">
          <div class="mb-2">
            <label>{{ $t('form-email') }}</label>
          </div>
          <div class="mb-2">
            <input type="email" v-model="email" :class="{'form-error': formErrors.includes('email')}" autocomplete="email" required>
          </div>

          <div class="mb-2 mt-4">
            <label>{{ $t('form-deletion-reason') }}</label>
          </div>
          <div class="mb-2">
            <textarea v-model="reason" rows="4" :class="{'form-error': formErrors.includes('reason')}" required></textarea>
            <div class="hint-text">{{ $t('form-deletion-reason-hint') }}</div>
          </div>

          <div class="mt-4 d-flex justify-content-center">
            <MainButton @click="sendForm">{{ $t('Request') }}</MainButton>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  max-width: 600px;
  color: $color-purple;
}
.title {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 20px;
  color: $color-purple;
}
label {
  font-size: 14px;
  color: $color-purple;
}

input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.form-error {
  border: 1px solid #a62a2a;
  background: #fffafa;
}

textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: vertical;
  font-family: inherit;
}

.hint-text {
  font-size: 12px;
  color: #6B6B9C;
  margin-top: 5px;
  line-height: 1.4;
}
</style>
<script setup>
import MainButton from '@/components/Common/Buttons/MainButton';
import {ref} from 'vue';
import NavigationBar from "@/components/NavigationBar.vue";
import axios from "axios";

const formErrors = ref([])

const email = ref(null)
const reason = ref(null)
// const phone = ref(null)
const sent = ref(false)
const err = ref(false)

async function sendForm() {
  try {
    sent.value = false;
    err.value = false;
    formErrors.value = [];

    const mailRegex = /\S+@\S+\.\S+/;
    if (email.value === null || email.value === '' || !mailRegex.test(email.value)) {
      formErrors.value.push('email');
    }

    if (reason.value === null || reason.value === '' || reason.value.trim() === '') {
      formErrors.value.push('reason');
    }

    if (formErrors.value.length > 0) {
      return Promise.resolve();
    }

    // Using Formspree for form handling (free service)
    await axios.post('https://formspree.io/f/mpwlnylv', {
      email: email.value,
      reason: reason.value,
      _subject: 'Account Deletion Request - Momfident',
      _captcha: false
    })

    formErrors.value = [];
    sent.value = true
  } catch (err) {
    console.log(err);
    err.value = true
  }
}
</script>
